<template>
  <div class="peopleInfo-wrap section-main__warp tree-line-style">
    <visitor-dialog ref="visitorRef" :departmentData="departmentData" @getList="getUpdate"></visitor-dialog>
    <div class="flex-row flex-auto" style="overflow: hidden">
      <!-- 员工信息左侧部门树 -->
      <div class="section-mian_left">
        <div class="left_title">名单信息</div>
        <div class="peopleInfo-tab">
          <div v-for="item in tabs" :key="item.typeId" :class="['tab', personType.typeId == item.typeId ? 'active' : '']"
            @click="handleChange(item)">
            {{ item.label }}
          </div>
        </div>
        <div class="area-search">
          <el-input placeholder="请输入搜索关键字" prefix-icon="el-icon-search" v-model="searchString" clearable>
          </el-input>
        </div>
        <el-scrollbar v-show="personType.prop === 'staff'" style="padding-bottom: 15px" class="flex-auto">
          <el-tree ref="tree" class="tree-content" :data="departmentData" :expand-on-click-node="false"
            :check-on-click-node="true" node-key="id" default-expand-all :props="treeProps" :highlight-current="true"
            :filter-node-method="filterNode" :default-checked-keys="menuCheckedKeys" @node-click="handleNodeClick">
            <template slot-scope="{ node, data }">
              <element-tree-line :node="node" :showLabelLine="true" :indent="16" class="tree-line">
                <span class="custom-tree-node">
                  <span :title="node.label" class="view-label">{{ node.label }}</span>
                  <div class="area-operator" v-if="checkNodeLeft.id == data.id">
                    <el-button type="text" size="medium" class="el-icon-view" title="详情"
                      @click.stop="viewDepartment(data)"></el-button>
                  </div>
                </span>
              </element-tree-line>
            </template>
          </el-tree>
        </el-scrollbar>
        <el-scrollbar v-show="personType.prop === 'visitor'" class="flex-auto" style="padding-bottom: 15px">
          <el-tree ref="rightTree" class="tree-content" :data="visitorType" :expand-on-click-node="false"
            node-key="visitorTypeCode" :props="defaultProps" :highlight-current="true" :default-expand-all="true"
            :filter-node-method="filterNode" :default-checked-keys="menuCheckedKeys" @node-click="handleNodeClick">
            <template slot-scope="{ node, data }">
              <element-tree-line :node="node" :showLabelLine="true" :indent="16" class="tree-line">
                <span class="custom-tree-node">
                  <span :title="node.label" class="view-label">{{ node.label }}</span>
                  <div class="area-operator">
                    <el-button v-if="data.isParent" type="text" size="medium" @click.stop="addType"
                      class="el-icon-circle-plus-outline" title="新增"></el-button>
                    <el-button v-if="!data.isParent &&
                      checkNodeRight.visitorTypeCode == data.visitorTypeCode
                      " type="text" size="medium" class="el-icon-edit-outline" title="修改"
                      @click.stop="() => editType(node, data)"></el-button>
                    <el-button v-if="!data.isParent &&
                      checkNodeRight.visitorTypeCode == data.visitorTypeCode
                      " type="text" size="medium" class="el-icon-delete-solid" title="删除"
                      @click.stop="() => deleteClick(node, data)"></el-button>
                  </div>
                </span>
              </element-tree-line>
            </template>
          </el-tree>
        </el-scrollbar>
      </div>
      <!-- 右侧表格-->
      <div class="flex-auto flex-valign" style="overflow: hidden">
        <ioc-table ref="crud" :class="tableOption.tableClass" :data="tableData" :option="tableOption" :page="page"
          @size-change="changeSize" @current-change="currentChange" @selection-change="selectionChange"
          @search-change="searchList" @search-reset="resetQuery">
          <!-- menuLeft -->
          <template slot="menuLeft">
            <el-button type="primary" icon="el-icon-plus" @click="addVisitor">新增</el-button>
            <el-button type="primary" v-if="personType.typeId == '2'" icon="iconfont icon-daoru" @click="moveIn">{{
              $t("cameraList.button.moveInto") }}</el-button>
            <!-- <el-button type="primary" icon="el-icon-delete-solid" @click="deleteBtn">批量删除</el-button> -->
            <el-button type="primary" v-if="personType.typeId == '1'" icon="el-icon-refresh"
              @click="handleSyncDahuaDept">同步部门</el-button>
            <el-button type="primary" v-if="personType.typeId == '1'" icon="el-icon-refresh-right"
              @click="handleSyncDahuaPersonnel">同步人员</el-button>
          </template>
          <!-- <template slot="personnelMark" slot-scope="scope">
            <span>{{ personnelMarkRender(scope.row.personnelMark) }}</span>
          </template> -->
          <template slot="img" slot-scope="scope">
            <img :src="getImgPath(scope.row.facePicFileCode)"
              @click="showViewer(getImgPath(scope.row.facePicFileCode), $event)"
              onerror="this.src='/images/theme/newDark/default.png'" style="height: 25px; width: 50px; cursor: pointer" />
          </template>
          <template slot="status" slot-scope="scope">
            <span v-if="scope.row.status === 1" style="color: #00e8bb; cursor: pointer"
              @click="handleView(scope.row, scope.index)">{{ statusFormatter(scope.row) }}</span>
            <span v-if="scope.row.status === 2">{{ statusFormatter(scope.row) }}</span>
            <span v-if="scope.row.status === 4" style="color: yellow">{{
              statusFormatter(scope.row)
            }}</span>
          </template>
          <template slot="menu" slot-scope="scope">
            <el-tooltip class="item m5" effect="dark" content="修改" placement="top-start">
              <el-button type="text" class="iconfont icon-blue icon-xiugai" @click.native="updateBtn(scope.row)"
                style="font-size: 14px;"></el-button>
            </el-tooltip>
            <el-tooltip class="item m5" effect="dark" content="删除" placement="top-start">
              <el-button type="text" class="iconfont-lunan icon-blue icon-lunan-shanchu" @click="deleteBtn(scope.row)"
                style="font-size: 16px;"></el-button>
            </el-tooltip>
            <!-- <el-tooltip
              class="item m5"
              effect="dark"
              v-if="personType.prop != 'visitor'"
              content="设置权限"
              placement="top-start"
            >
              <el-button
                type="text"
                style="font-size: 16px"
                icon="iconfont icon-zhanghushezhi"
                @click="handleSet(scope.row)"
              ></el-button>
            </el-tooltip> -->
            <!-- <el-tooltip class="item m5" effect="dark" content="查询轨迹" placement="top-start">
              <el-button type="text" style="font-size: 16px" class="iconfont-lunan icon-blue el-icon-location"
                @click="handleTrack(scope.row)"></el-button>
            </el-tooltip> -->
          </template>
          <!-- 详情中图片 -->
          <template slot="imgView" slot-scope="scope">
            <img :src="getImgPath(scope.row.facePicFileCode)"
              @click="showViewer(getImgPath(scope.row.facePicFileCode), $event)"
              onerror="this.src='/images/theme/newDark/default.png'" style="height: 25px; width: 50px; cursor: pointer" />
          </template>
          <!-- 详情中状态 -->
          <template slot="statusView" slot-scope="scope">
            <span v-if="scope.row.status === 1" style="color: #00e8bb">
              {{ statusFormatter(scope.row) }}</span>
            <span v-if="scope.row.status === 2"> {{ statusFormatter(scope.row) }}</span>
            <span v-if="scope.row.status === 4" style="color: yellow">
              {{ statusFormatter(scope.row) }}</span>
          </template>
        </ioc-table>
      </div>
    </div>
    <!-- 新增弹窗 -->
    <el-dialog :title="state === 1 ? '新增类型' : '修改类型'" v-ops:width="480" :visible.sync="formShow" @close="handleCloseForm"
      :close-on-click-modal="false">
      <ioc-forms :option="formOption" :formData="formData" ref="form"></ioc-forms>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseForm"> 取消 </el-button>
        <el-button type="primary" @click="handleSaveForm"> 保存 </el-button>
      </span>
    </el-dialog>
    <!--选择类型树-->
    <el-dialog v-ops:width="450" v-dialogDrag title="选择挪入外来人员类型" :visible.sync="typeTreeShow">
      <el-scrollbar style="height: 450px">
        <el-tree :data="typeData" :highlight-current="true" :props="defaultProps" :default-expand-all="true"
          @node-click="selectNode"></el-tree>
      </el-scrollbar>

      <span slot="footer" class="dialog-footer">
        <el-button @click="typeTreeShow = false">{{
          $t("cameraList.button.cancel")
        }}</el-button>
        <el-button type="primary" @click="moveVisitorType('1')">{{
          $t("cameraList.button.conform")
        }}</el-button>
      </span>
    </el-dialog>
    <!--部门详情弹框-->
    <el-dialog v-ops:width="480" width="30%" title="部门详情" :visible.sync="departmentShow">
      <el-form :model="departmentInfoForm">
        <el-form-item label="上级部门" label-width="120px" v-if="departmentInfoForm.parentName">
          <el-input v-model="departmentInfoForm.parentName" autocomplete="off" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="部门名称" label-width="120px">
          <el-input v-model="departmentInfoForm.departmentName" autocomplete="off" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="部门code" label-width="120px">
          <el-input v-model="departmentInfoForm.departmentCode" autocomplete="off" :disabled="true"></el-input>
        </el-form-item>
        <!-- <el-form-item label="部门负责人" label-width="120px">
          <el-input
            v-model="departmentInfoForm.leaderName"
            autocomplete="off"
            :disabled="true"
          ></el-input>
        </el-form-item> -->
      </el-form>
    </el-dialog>
    <groupsVue :personnelCode="personnelCode" :showGroupsPanel="showGroupsPanel"
      @handleCloseGroupsPanel="handleCloseGroupsPanel" />
    <dialog-map ref="dialogMap"></dialog-map>
  </div>
</template>
<script>
// 工具库
import { Bus } from "$utils";
import tableOption from "../options/table";
import visitorTypeOption from "../options/visitorType";
import VisitorDialog from "../components/VisitorDialog";
import groupsVue from "../components/group";
import dialogMap from "@src/components/common/app-dialog/dialog-mapNew";
import { api } from "../api";
import utils from "@src/common/utils";
import ElementTreeLine from "element-tree-line";
const trim = (str) => {
  return str.replace(/^\s+|\s+$/g, "");
};
export default {
  name: "perimeter",
  components: {
    VisitorDialog,
    dialogMap,
    ElementTreeLine,
    groupsVue,
  },
  watch: {
    searchString(val) {
      if (this.personType.prop === "staff") {
        this.$refs.tree.filter(val);
      } else {
        this.$refs.rightTree.filter(val);
      }
    },
  },
  data() {
    return {
      personnelCode: "",
      showGroupsPanel: false,
      dataLoading: false,
      checkNodeLeft: {},
      checkNodeRight: {},
      menuCheckedKeys: [],
      personCodeList: [], //外来人员code,
      activeName: "",
      searchString: "",
      tabs: [
        {
          label: "集团员工",
          prop: "staff",
          typeId: "1",
        },
        {
          label: "外来临员",
          prop: "visitor",
          typeId: "2",
        },
      ],
      tableOption: tableOption(true, true),
      personType: {},
      tableData: [],
      page: {
        currentPage: 1,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
        total: 0,
      },
      searchParams: {},
      formShow: false,
      visitorType: [
        {
          children: [],
          isParent: true,
          visitorTypeName: "外来人员类型",
          visitorTypeCode: 1,
        },
      ],
      // 表单配置项
      formOption: visitorTypeOption(),
      formData: {
        name: "",
        type: "",
      },
      state: 1, // 1: 新增 2：修改
      visitorTypeCode: "", //外来人员类型code
      activeStyle: "",
      personnelType: 1,
      typeTreeShow: false,
      checkedIds: [],
      defaultProps: {
        children: "children",
        label: "visitorTypeName",
      },
      typeData: [
        {
          visitorTypeName: "外来人员类型",
          visitorTypeCode: "-1",
          children: [],
        },
      ],
      visitorTypeCodeList: [],
      // 部门树的props
      treeProps: {
        children: "children",
        label: "name",
        id: "deptCode",
        isLeaf: "isLeaf",
      },
      //
      lazyLoad: false,
      departmentData: [],
      departmentCodeList: [],
      departmentShow: false,
      departmentInfoForm: {},
      personnelMarkArr: []
    };
  },
  created() {
    // this.getPersonType()
    this.personType = this.tabs[0];
    this.getDepartmentTree();
    this.getVisitorList();
    // 默认进入页面选中第一种分类方式
  },
  mounted() {
    // this.getList(1);
  },
  methods: {
    // 查询员工类型
    getPersonType() {
      this.$fetch(api.queryPersonType, {}).then((res) => {
        if (!res.success) {
          this.$$message.error(res.msgContent || "获取数据失败");
          return;
        }
        const TypeData = res.returnObj;
        this.personnelMarkArr = TypeData.map(item => {
          return {
            label: item.personnelMarkName,
            value: item.personnelMark
          }
        })
        // console.log(this.personnelMarkArr, '############')
      });
    },
    personnelMarkRender(value) {
      for (let i = 0; i < this.personnelMarkArr.length; i++) {
        if (this.personnelMarkArr[i].value == value) {
          return this.personnelMarkArr[i].label
        }
      }
    },
    handleSyncDahuaDept() {
      this.$confirm("您确定进行同步部门操作吗?", "操作确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch(api.syncDahuaDept, {}).then((res) => {
          if (res.success) {
            this.$message.success(res.msgContent);
          } else {
            this.$message.error(res.msgContent);
          }
        });
      });
    },
    handleSyncDahuaPersonnel() {
      this.$confirm("您确定进行同步人员操作吗?", "操作确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch(api.syncDahuaPersonnel, {}).then((res) => {
          if (res.success) {
            this.$message.success(res.msgContent);
          } else {
            this.$message.error(res.msgContent);
          }
        });
      });
    },
    handleCloseGroupsPanel(type) {
      this.showGroupsPanel = false;
    },
    getUpdate(type) {
      if (this.checkNodeRight.isParent) {
        this.getList(type);
      } else {
        this.getList(type, this.checkNodeRight.visitorTypeCode);
      }
    },
    handleNodeClick(data) {
      this.page.currentPage = 1;
      this.page.pageSize = 10;
      if (this.personType.typeId === "1") {
        this.checkNodeLeft = data;
        this.departmentCodeList = [];
        if (data.children && data.children.length) {
          const list = this.getAllNode(data.children);
          list.unshift(this.checkNodeLeft.id);
          this.departmentCodeList = list;
        } else {
          this.departmentCodeList.push(this.checkNodeLeft.id);
        }
        this.getList(1);
      } else {
        this.checkNodeRight = data;
        if (data.isParent) {
          this.getList(2);
        } else {
          this.visitorTypeCode = data.visitorTypeCode;
          this.getList(2, data.visitorTypeCode);
        }
      }
    },
    // 递归获取父节点下所有子节点的id
    getAllNode(arr, name, childName) {
      let str = "";
      const arrs = [];
      if (!arr) {
        return;
      }
      if (!name) {
        name = "id";
      }
      if (!childName) {
        childName = "children";
      }
      const getChild = (arr) => {
        for (let i = 0; i < arr.length; i++) {
          arrs.push(arr[i][name]);
          if (arr[i][childName] && arr[i][childName].length > 0) {
            getChild(arr[i].children);
          }
        }
        return arrs;
      };
      return getChild(arr);
    },
    //模板下载
    downTemplate() {
      this.$fetchGet(
        "/common/file/downLoadTemplateFile.json?templateFileName=importPersonnelTemplate.xlsx",
        {
          responseType: "blob", //设置返回类型
        }
      ).then((res) => {
        const downFileName = "importPersonnelTemplate";
        console.log(res);
        if (typeof window.chrome !== "undefined") {
          // Chrome version
          const blob = new Blob([res], { type: "application/vnd.ms-excel" });
          const url = window.URL || window.webkitURL || window.moxURL;
          const urls = url.createObjectURL(blob);
          const a = document.createElement("a"); // 生成虚拟a标签
          a.href = urls;
          a.download = downFileName + ".xlsx";
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          url.revokeObjectURL(urls); // 释放掉blob对象
        } else if (typeof window.navigator.msSaveBlob !== "undefined") {
          // IE version
          const blob = new Blob([res], { type: "application/force-download" });
          window.navigator.msSaveBlob(blob, downFileName + ".xlsx");
        } else {
          // Firefox version
          const file = new File([res], downFileName + ".xlsx", {
            type: "application/force-download",
          });
          window.open(URL.createObjectURL(file));
        }
        console.log(downFileName, "=====this.downFileName");
      });
    },
    addVisitor() {
      console.log(this.personType.typeId);
      this.$refs.visitorRef.open({ tabType: this.personType.typeId }, "新增");
    },
    // 批量导入按钮
    batchImport(file) {
      if (
        file.name.substring(file.name.lastIndexOf(".") + 1, file.name.length) !==
        "xlsx" &&
        file.name.substring(file.name.lastIndexOf(".") + 1, file.name.length) !== "xls"
      ) {
        this.$message({
          message: "文件格式不正确",
          type: "warning",
        });
      } else {
        let formData = new FormData();
        formData.append("file", file.raw);
        formData.append("operateType", this.personnelType);
        // 调用导入接口
        this.$fetch("/vas/personnel/importPersonnel.json", formData).then((response) => {
          if (response.success) {
            this.$message({
              message: "导入文件成功",
              type: "success",
            });
            this.getList(2);
          } else {
            this.$message({
              message: response.msgContent,
              type: "error",
            });
          }
          this.$refs.upload.clearFiles();
        });
      }
    },
    updateBtn(row) {
      // if (this.personType.prop == "staff") {
      // this.$nextTick(() => {
      //   if (row.visitorTypeName == null) {
      //     row.visitorTypeCode = "";
      //     row.visitorTypeName = "";
      //   }
      this.$refs.visitorRef.open({ ...row, tabType: this.personType.typeId }, "修改");
      // });
    },
    //外来人员删除
    deleteBtn(row) {
      if (row && row.personnelCode) {
        this.checkedIds = [row.personnelCode];
      }
      console.log(this.checkedIds);
      if (!this.checkedIds.length) {
        this.$message.warning("请选择要删除的人员");
        return;
      }
      this.$confirm("您确定删除该人员信息吗?", "删除确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        //this.personCodeList.push(row.personnelCode)
        const param = {
          personCodeList: this.checkedIds,
        };
        this.$fetch("/vas/personnel/deletePersonnel.json", param).then((res) => {
          if (res.success) {
            this.$message.success("删除成功");
            //Tab保持当前位置，刷新列表
            // this.tableOption = tableOption(false, true);
            if (this.personType.prop == "staff") {
              // this.getList(1, this.visitorTypeCode);
              this.getList(1);
            } else {
              this.getList(2, this.visitorTypeCode);
            }
            this.addBlackList(row)
          } else {
            this.$message.error(res.msgContent);
          }
        });
      });
    },
    addBlackList(data) {
      this.$confirm("是否确定将该人员添加至黑名单组吗?", "人员黑名单添加确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        const param = {
          "repositorCode": "20231205000004",
          "name": data.name,
          "sex": data.sex,
          "phone": data.phone,
          "birthday": "2023-12-05",
          "fileCode": data.facePicFileCode,
          "attachments": [{ "fileCode": data.facePicFileCode }],
          "credentialType": 5,
          "credentialNumber": data.personnelCode
        }
        this.$fetch("/vas/bwlist/addPersonnelBwlist.json", param).then((res) => {
          if (res.success) {
            this.$message.success("添加成功");
            this.queryPeopleCar(data)
          } else {
            this.$message.error("添加失败");
          }
        })
      })
    },
    queryPeopleCar(data) {
      let param = {
        'personnelCode': data.personnelCode
      }
      this.$fetch("/vas/personnel/queryPersonnelVehicle.json", param).then((res) => {
        if (res.success) {
          if (res.returnObj.length > 0) {
            this.addCarBlackList(res.returnObj, data)
          }
        } else {
          this.$message.error(res.msgContent);
        }
      })
    },
    addCarBlackList(data, value) {
      let addPerson = []
      for (let i = 0; i < data.length; i++) {
        addPerson.push({
          "ownerName": value.name,
          "vehicleColor": "",
          "vehicleBrand": "",
          "vehicleType": "",
          "plateCode": data[i].plateCode,
          "desc": "",
          "repositorCode": "20231009000003",
          "vehicleList": [],
          "type": 0
        })
      }
      this.$confirm("是否确定将该人员车辆添加至黑名单组吗?", "车辆黑名单添加确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        const param = {
          'list': addPerson
        }
        this.$fetch("/vas/vehicleRepositories/addBwPlateList.json", param).then((res) => {
          if (res.success) {
            this.$message.success("添加成功");
          } else {
            this.$message.error("添加失败");
          }
        })
      })
    },
    imgPath(item) {
      return item ? Bus.imgPath(item) : "";
    },
    handleSet(row) {
      this.personnelCode = row.personnelCode;
      this.showGroupsPanel = true;
      // console.log(row);
    },
    handleTrack(row) {
      this.$refs.dialogMap.openMap(row);
    },
    // 获取部门树结构
    getDepartmentTree() {
      const param = { type: 1 };
      this.$fetch(api.queryDeptTree, param).then((res) => {
        if (res.success) {
          this.departmentData = this.menusDataPro2(res.returnObj);
          this.handleNodeClick(this.departmentData[0]);
          this.$nextTick(() => {
            this.$refs.tree.setCurrentKey(this.departmentData[0]);
          });
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    // 获取部门负责人接口
    getDepartmentDetail(code) {
      const param = {
        departmentCode: code,
      };
      this.$fetch(api.queryDepartmentDetail, param).then((res) => {
        if (res.success) {
          this.departmentInfoForm = res.returnObj;
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    //递归部门树结构
    menusDataPro2(data) {
      const self = this;
      const result = [];
      if (data !== null) {
        data.forEach(function (item) {
          const entity = {};
          entity.id = item.deptCode;
          entity.name = item.deptName;
          entity.desc = item.desc;
          entity.parentCode = item.parentCode;
          entity.parentName = item.parentName;
          entity.isLeaf = !item.hasLeaf || !item.children;
          if (item.children && item.children.length) {
            entity.children = self.menusDataPro2(item.children);
          }
          result.push(entity);
        });
        return result;
      }
    },
    viewDepartment(data) {
      console.log(data);
      // this.getDepartmentDetail(data.id);
      this.departmentInfoForm.departmentName = data.name;
      this.departmentInfoForm.departmentCode = data.id;
      this.departmentInfoForm.parentName = data.parentName;
      this.departmentShow = true;
    },
    // 异步加载树子节点 加载子树数据的方法，仅当 lazy 属性为true 时生效
    asyncLoadNode(node, resolve) {
      if (node.data && node.data.children) {
        return resolve(node.data.children);
      } else {
        return resolve([]);
      }
    },
    filterNode(value, data) {
      if (!value) {
        return true;
      }
      if (this.personType.prop === "staff") {
        return data.name.indexOf(value) !== -1;
      } else {
        return data.visitorTypeName.indexOf(value) !== -1;
      }
    },
    statusFormatter(data) {
      switch (data.status * 1) {
        // 1:待接待人审批,2:接待人审批通过,待部门负责人审批3:部门负责人审批通过,待区域负责人审批4:区域负责人同意5:拒绝'
        case 1:
          return "在职";
        case 2:
          return "离职";
        case 4:
          return "未知";
        default:
          return data.status;
      }
    },
    // 获取外来人员类型组接口
    getVisitorList() {
      this.$fetch(api.getVisitorTypeList, {}).then((res) => {
        if (res.success) {
          this.visitorType[0].children = res.returnObj;
          this.typeData[0].children = res.returnObj;
          this.$nextTick(() => {
            this.$refs.rightTree.setCurrentKey(this.visitorType[0]);
          });
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    showViewer(src, e) {
      this.$app.AppInstance.handleShowViewer([e.target.src]);
    },
    getImgPath(item) {
      return item ? Bus.imgPath(item) : "";
    },
    addType(type) {
      this.state = 1;
      this.formShow = true;
    },
    // 新增/修改保存外来人员类型
    handleSaveForm() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let url = this.state === 1 ? api.addVisitorType : api.updateVisitorType;
          let params = {};
          if (this.state === 1) {
            params = {
              visitorTypeName: trim(this.formData.name),
            };
          } else {
            params = {
              visitorTypeName: trim(this.formData.name),
              visitorTypeCode: this.visitorTypeCode,
            };
          }
          this.$fetch(url, params).then((res) => {
            if (res.success) {
              this.$message({
                message: this.state === 1 ? "新增成功" : "修改成功",
                type: "success",
                duration: 2000,
              });

              this.formShow = false;
              this.getVisitorList();
              if (this.state === 1) {
                this.activeStyle = this.visitorType[0].name;
              } else {
                this.activeStyle = trim(this.formData.name);
              }
            } else {
              this.$message.error(res.msgContent);
            }
          });
        } else {
          return false;
        }
      });
    },
    // 新增修改弹窗 关闭清除数据
    handleCloseForm() {
      this.formShow = false;
      this.$refs["form"].$refs["form"].resetFields();
    },
    // 删除
    deleteClick(item, info) {
      this.$confirm("您确定删除该外来人员类型么?", "删除确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          visitorTypeCode: info.visitorTypeCode,
        };
        // this.getList(2, info.visitorTypeCode);
        setTimeout(() => {
          this.$fetch(api.deleteVisitorType, params).then((response) => {
            if (!response.success) {
              this.$message.error(response.msgContent);
              return;
            } else {
              this.visitorTypeCode = "";
              this.$message.success("删除成功");
              this.getList(2);
              this.getVisitorList();
            }
          });
        }, 500);
      });
    },
    // 修改
    editType(node, info) {
      console.log(info);
      this.formShow = true;
      this.state = 2;
      this.formData.name = info.visitorTypeName;
      console.log(this.formData);
      this.visitorTypeCode = info.visitorTypeCode;
    },
    // 切换选项卡
    handleChange(column) {
      this.page.currentPage = 1;
      this.page.pageSize = 10;
      this.personType = column;
      if (this.personType.typeId === "1") {
        this.tableOption = tableOption(true, true);
        this.getList(1);
      } else {
        this.tableOption = tableOption(false, true);
        this.getList(2);
      }
    },
    getList(personnelType, visitorCode) {
      const params = {};
      params.name = this.searchParams.name;
      params.personnelType = personnelType;
      if (personnelType == 1) {
        params.departmentCodeList = this.departmentCodeList;
      } else {
        if (visitorCode) {
          params.visitorTypeCode = visitorCode;
        }
      }
      params.phone = this.searchParams.phone;
      params.workNo = this.searchParams.workNo;
      params.status = this.searchParams.status;
      params.pageNum = this.page.currentPage;
      params.pageSize = this.page.pageSize;
      // const loading = this.$loading({
      //   lock: true,
      //   text: "请求中",
      //   spinner: "el-icon-loading",
      //   background: "rgba(0, 0, 0, 0.7)"
      // });
      this.$fetch(api.queryPersonList, params).then((response) => {
        // setTimeout(() => {
        //   loading.close();
        // }, 500);
        if (!response.success) {
          this.$message.error(response.msgContent);
          return;
        }
        this.tableData = response.returnObj
          ? Object.freeze([...response.returnObj.list])
          : [];
        this.page.total = response.returnObj ? response.returnObj.total : 0;
        this.$refs.crud.selectClear();
      });
    },
    // 重置按钮
    resetQuery() {
      if (this.personType.prop === "staff") {
        this.getList(1);
      } else {
        this.getList(2, this.visitorTypeCode);
      }
    },

    //同步获取数据
    getData() {
      this.dataLoading = true;
      this.$fetch(api.syncPersonnel).then((res) => {
        this.dataLoading = false;
        if (res.success) {
          this.$message.success("同步成功");
          this.getList(1);
        } else {
          if (res.msgCode === "104008802010002") {
            this.$message.success(res.msgContent);
          } else {
            this.$message.error(res.msgContent);
          }
        }
      });
    },
    // 修改每页数据数量
    changeSize(val) {
      this.page.currentPage = 1;
      this.page.pageSize = val;
      //调用列表接口
      if (this.personType.prop === "staff") {
        this.getList(1);
      } else {
        this.getList(2, this.visitorTypeCode);
      }
    },
    // 点击上一页下一页按钮
    currentChange(val) {
      this.page.currentPage = val;
      //调用列表接口
      if (this.personType.prop === "staff") {
        this.getList(1);
      } else {
        this.getList(2, this.visitorTypeCode);
      }
    },
    searchList(param) {
      if (this.personType.prop === "staff") {
        console.log("--param---", param);
        this.searchParams = Object.assign(param, this.obj);
        this.page.currentPage = 1;
        this.getList(1);
      } else {
        this.searchParams = Object.assign(param);
        this.page.currentPage = 1;
        this.getList(2, this.visitorTypeCode);
      }
    },
    // 当选择项发生变化时会触发该事件
    selectionChange(items) {
      this.checkedIds = items.map((item) => {
        return item.personnelCode;
      });
    },
    selectNode(data, node) {
      console.log("node", node);
      this.selectedNode = data.visitorTypeCode;
      // this.activeStyle = data.visitorTypeName
    },
    //挪入
    moveIn() {
      if (!this.checkedIds.length) {
        this.$message({
          message: "请选择挪入外来人员",
          type: "warning",
        });
        return;
      }
      this.slectedAreaNode = "";
      this.typeTreeShow = true;
    },
    //挪出
    moveOut() {
      if (!this.checkedIds.length) {
        this.$message({
          message: "请选择挪出外来人员",
          type: "warning",
        });
        return;
      }
      this.$confirm("是否要挪出外来人员", "确认", {
        confirmButtonText: this.$t("cameraList.button.conform"),
        cancelButtonText: this.$t("cameraList.button.cancel"),
        type: "warning",
      }).then(() => {
        this.selectedNode = this.visitorVehicleTypeCode;
        this.moveVisitorType("2");
      });
    },
    moveVisitorType(operateType) {
      if (!this.selectedNode || this.selectedNode == -1) {
        this.$message.warning("请选择类型");
        return;
      }
      const params = {
        personCodeList: this.checkedIds,
        operateType: operateType,
        visitorTypeCode: this.selectedNode,
      };
      this.$fetch(api.updateVisitorVisitorType, params).then((res) => {
        if (res.success) {
          this.$message.success(operateType == "1" ? "挪入成功" : "挪出成功");
          this.typeTreeShow = false;
          this.getList(2, this.visitorVehicleTypeCode);
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    handleView(row, index) {
      this.$refs.crud.rowView(row, index);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";

.left_title {
  border-left: 4px solid #407aee;
  padding-left: 8px;
  margin: 16px;
}

.peopleInfo-wrap {
  .peopleInfo-tab {
    display: flex;
    margin: 0 16px 0px 16px;

    .tab {
      // color: #9aa6c1;
      flex: 1;
      text-align: center;
      padding-bottom: 10px;
      border-bottom: 1px solid #707070;
      // @include set_theme_color(border-color, border-color);

      &:hover {
        // color: #fff;
        @include set_theme_color(color, font-active-color);
        cursor: pointer;
      }
    }

    .active {
      @include set_theme_color(color, font-active-color);
      // color: #fff;
      border-color: #407aee;
    }
  }

  .ioc-table {
    padding-top: 0;
  }

  .visitor-btn {
    padding: 10px;

    .upload-demo {
      padding-left: 10px;
    }
  }

  .section-mian_left {
    width: 380px;
    margin-right: 8px;
    display: flex;
    flex-direction: column;

    .area-search {
      display: flex;
      margin: 15px 16px;
      height: 28px;

      .el-input {
        width: 100%;
      }
    }

    .tree-content {
      width: fit-content;
      min-width: 100%;

      .el-tree-node__label {
        display: inline-block;
        max-width: 80%;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }

      .el-tree-node__content {
        height: 40px;
        line-height: 40px;

        &:hover {
          background: rgb(45, 73, 118);
        }

        .custom-tree-node {
          width: 100%;
          height: 40px;
          line-height: 40px;

          .view-label {
            display: inline-block;
            width: 240px;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }

          .area-operator {
            display: block;
            width: 50px;
            margin-left: 10px;

            .el-icon-circle-plus-outline {
              font-size: 16px;
            }

            .el-button {
              // color: #fff !important;
            }
          }

          &:hover {
            .area-operator {
              display: inline-block;
              margin-left: 10px;
            }
          }
        }

        &:before {
          margin-top: -26px !important;
        }
      }
    }

    .list-item {
      .title {
        line-height: 35px;
        display: flex;
        flex-direction: row;
        align-items: center;

        &:hover,
        &.active {
          background-color: #3f619b;
        }

        i {
          color: #939cad;
        }

        .el-icon-plus {
          cursor: pointer;
        }

        .changeStyle {
          position: absolute;
          right: 10px;
        }
      }

      .list-text {
        padding-left: 20px;
        line-height: 35px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        display: flex;
        align-items: center;

        &:hover,
        &.active {
          background-color: #3f619b;
        }

        &:hover {
          .tree-icon {
            display: inline-block;
          }
        }

        .list-name {
          width: 140px;
          display: inline-block;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .tree-icon {
          position: absolute;
          right: 0px;
          cursor: pointer;
          display: none;
          width: 35px;
          line-height: 35px;
        }
      }
    }
  }

  .hide {
    display: none;
  }

  .show {
    display: block;
  }
}
</style>
